import type { FeatureId } from "@/server-types";

export type ChatBookingPermissions = {
  view_chat_booking?: boolean;
  edit_chat_booking?: boolean;
};

export function canViewChatBooking({
  isFeatureEnabled,
  permissions,
}: {
  isFeatureEnabled: (feature: FeatureId) => boolean;
  permissions: ChatBookingPermissions;
}): boolean {
  return isFeatureEnabled("chatBooking") && !!permissions.view_chat_booking;
}

export function canEditChatBooking({
  isFeatureEnabled,
  permissions,
}: {
  isFeatureEnabled: (feature: FeatureId) => boolean;
  permissions: ChatBookingPermissions;
}): boolean {
  return (
    canViewChatBooking({ isFeatureEnabled, permissions }) &&
    !!permissions.edit_chat_booking
  );
}
